<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content" style="padding: 0px;">
        <div class="form-items" v-if="step ==1">
          <span class="logo" v-html="logos"></span>

              <div class="row mt-5">
            </div>
          <!-- <h3>Welcome to Screenit</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer placerat mi fringilla mauris ullamcorper</p> -->
          <div class="container">
            <b-form class="register-form" v-on:submit.prevent="onSubmitProfileRegister" novalidate style="background-color: #ffffff;padding: 20px;">
              <div>
                <div class="form-row">
                  <h3 class="float-left mb-0 ml-3">Organization Details</h3>
                </div>
                <hr>
              <div class="form-group profile-image-center">
                <!-- <svg v-if="!imageAvailable" @click="inputImage" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><defs><style>.cls-1{fill:#d5d5d5;}.cls-2,.cls-4{fill:none;}.cls-2{stroke:#d6d6d6;}.cls-3{fill:#fff;stroke:#dedede;stroke-width:0.5px;}.cls-4{stroke:#393939;stroke-linecap:round;stroke-linejoin:round;}</style></defs><path class="cls-1" d="M40,5.39a35,35,0,1,0,35,35A35,35,0,0,0,40,5.39ZM40,15.6A16.77,16.77,0,1,1,23.23,32.37,16.79,16.79,0,0,1,40,15.6Zm0,54A29.13,29.13,0,0,1,16.69,57.85C22.53,55,30.86,52.06,40,52.06s17.47,3,23.31,5.79A29.13,29.13,0,0,1,40,69.56Z"/><path class="cls-2" d="M40,73.39a33,33,0,1,0-33-33A33,33,0,0,0,40,73.39Z"/><circle class="cls-3" cx="66.5" cy="63.89" r="8.25"/><path class="cls-4" d="M65.84,60.3h-3a.85.85,0,0,0-.6.24.88.88,0,0,0-.25.61v6a.85.85,0,0,0,.85.86h6a.85.85,0,0,0,.85-.86v-3"/><path class="cls-4" d="M69,59.65a.92.92,0,0,1,1.28,0,.91.91,0,0,1,.27.65.93.93,0,0,1-.27.64l-4,4-1.71.43L65,63.71Z"/></svg> -->
                <svg v-if="!imageAvailable" @click="toggleShow" id="Layer_1" width="100" height="100" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><path d="M40,5.39a35,35,0,1,0,35,35h0A35,35,0,0,0,40,5.39ZM40,15.6A16.77,16.77,0,1,1,23.23,32.37h0A16.79,16.79,0,0,1,40,15.6Zm0,54A29.13,29.13,0,0,1,16.69,57.85,54.34,54.34,0,0,1,40,52.06c9.14,0,17.47,3,23.31,5.79A29.12,29.12,0,0,1,40,69.56Z" fill="#d5d5d5"/><path d="M40,73.39a33,33,0,1,0-33-33H7A33,33,0,0,0,40,73.39Z" fill="none" stroke="#d6d6d6"/><circle cx="66.5" cy="63.89" r="8.25" fill="#fff" stroke="#dedede" stroke-width="0.5"/><path d="M65.84,60.3h-3a.85.85,0,0,0-.6.24.86.86,0,0,0-.25.61v6a.85.85,0,0,0,.84.86h6a.85.85,0,0,0,.85-.85h0v-3" fill="none" stroke="#393939" stroke-linecap="round" stroke-linejoin="round"/><path d="M69,59.65a.91.91,0,0,1,1.28,0,.93.93,0,0,1,.27.65.91.91,0,0,1-.27.64l-4,4-1.71.43L65,63.71Z" fill="none" stroke="#393939" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <!-- <svg v-if="!imageAvailable" @click="inputImage" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">
                  <defs>
                  </defs>
                  <g transform="translate(0 0)">
                    <path class="screenit__profile_a" d="M36.342,104.286,13.158,116.664a20.836,20.836,0,0,0-3.721,2.591,78.947,78.947,0,0,0,99.77.253,20.6,20.6,0,0,0-4.087-2.68L80.294,104.679a9.248,9.248,0,0,1-5.234-8.288V86.858A36.817,36.817,0,0,0,77.409,83.9,55.444,55.444,0,0,0,85.126,68.68a7.655,7.655,0,0,0,5.53-7.261V51.243a7.528,7.528,0,0,0-2.6-5.639V30.894S91.146,8,59.47,8,30.882,30.894,30.882,30.894V45.6a7.518,7.518,0,0,0-2.6,5.639V61.42a7.593,7.593,0,0,0,3.595,6.4,50.13,50.13,0,0,0,9.4,19.035v9.3A9.248,9.248,0,0,1,36.342,104.286Z" transform="translate(15.549 12.86)" />
                    <g transform="translate(0 0)">
                      <path class="screenit__profile_b" d="M76.285.011C34.869-.7.719,32.577.011,74.342a75.671,75.671,0,0,0,26.729,59.118,19.932,19.932,0,0,1,3.558-2.552L52.677,118.6a9.231,9.231,0,0,0,4.763-8.091v-9.247a50.326,50.326,0,0,1-9.074-18.931A7.606,7.606,0,0,1,44.9,75.96V65.839A7.583,7.583,0,0,1,47.4,60.231V45.6S44.424,22.833,75,22.833,102.6,45.6,102.6,45.6v14.63a7.573,7.573,0,0,1,2.508,5.608V75.96a7.582,7.582,0,0,1-5.338,7.221,55.8,55.8,0,0,1-7.449,15.138,36.462,36.462,0,0,1-2.267,2.94v9.481a9.221,9.221,0,0,0,5.052,8.243l23.964,12.082a19.944,19.944,0,0,1,3.934,2.66,75.679,75.679,0,0,0,26.99-56.8C150.7,35.163,117.7.725,76.285.011Z" transform="translate(0 0)" />
                    </g>
                  </g>
                </svg> -->
                <!-- <input type="file" ref="input" style="display: none" accept="image/*" @change="onProfileUpload"> -->
                <img class="image-design" v-if="imageAvailable" :src="imgDataUrl" @click="toggleShow" />
                <!-- <p v-if="imageAvailable" @click="removeImage"><span class="glyphicon glyphicon-trash" ></span>Delete</p> -->
                <i aria-hidden="true" v-if="imageAvailable" @click="toggleShow" class="fa fa-pencil edit-icon"></i>
                <div class="row" v-if="showfileerror">
                  <p class="login-alert-msg error-content" style="text-align: center;margin-left: 44px;">* Choose your organization profile image</p>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <b-form-input type="text" placeholder="Organization Name*" v-model.lazy.trim="$v.form.organization.$model" :state="chkState('organization')" autofocus/>
                  <div v-if="$v.form.organization.$error">
                    <p v-if="!$v.form.organization.required" class="login-alert-msg error-content">* Enter your organization name</p>
                    <!-- <p v-if="!$v.form.organization.minLength" class="login-alert-msg error-content">* Organization name must have at least 3 character</p> -->
                    <p v-if="!$v.form.organization.maxLength" class="login-alert-msg error-content">* Organization name maximum 64 characters</p>

                  </div>
                </div>
                <div class="form-group">
                  <b-form-input type="text" placeholder="Enter Website URL" v-model.lazy.trim="$v.form.orgwebsiteurl.$model" :state="chkState('orgwebsiteurl')"/>
                  <div v-if="!$v.form.orgwebsiteurl.url">
                    <p class="login-alert-msg error-content">* Website must be a valid URL</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <div class="form-select">
                    <select id="orgtype" v-model="form.organizationType" class="form-control" v-bind:class="{ 'is-invalid': !chkState('organizationType'), 'not-chosen': !form.organizationType }">
                      <option value="" class="text" disabled>Organization Type*</option>
                      <option v-for="x in dropdown" v-bind:value="x" :key="x">{{x}}</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div>
                  <div v-if="$v.form.organizationType.$error">
                    <p v-if="!$v.form.organizationType.required" class="login-alert-msg error-content">* Select the organization type</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-select">
                    <select v-model="form.organizationSize" class="form-control" v-bind:class="{ 'is-invalid': !chkState('organizationSize'), 'not-chosen': !form.organizationSize }">
                      <option value="" class="text" disabled>Organization Size*</option>
                      <option value="<10"> {{asecond}} 10 </option>
                      <option value="11-50">11 to 50</option>
                      <option value="51-200">51 to 200</option>
                      <option value="201-500">201 to 500</option>
                      <option value="501-1000">501 to 1000</option>
                      <option value=">1000 ">> 1000 </option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div>
                  <div v-if="$v.form.organizationSize.$error">
                    <p v-if="!$v.form.organizationSize.required" class="login-alert-msg error-content">* Select the organization size</p>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <div class="form-select">
                    <select v-model.lazy.trim="$v.form.country.$model" @change="getState()" class="form-control" v-bind:class="{ 'is-invalid': !chkState('country'), 'not-chosen': !form.country }">
                      <option value="" class="text" disabled>Country*</option>
                      <option v-for="x in Country" :value="x" :key="x.id">{{x.name}}</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div>
                  <div v-if="$v.form.country.$error">
                    <p v-if="!$v.form.country.required" class="login-alert-msg error-content">* Select the country</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-select">
                    <select v-model="form.state" @change="getCity()" class="form-control" v-bind:class="{ 'is-invalid': !chkState('state'), 'not-chosen': !form.state }">
                      <option value="" class="text" disabled>State*</option>
                      <option v-for="x in State" :value="x" :key="x.id">{{x.name}}</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div>
                  <div v-if="$v.form.state.$error">
                    <p v-if="!$v.form.state.required" class="login-alert-msg error-content">* Select the state</p>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <div class="form-select">
                    <select v-model="form.city" class="form-control" v-bind:class="{ 'is-invalid': !chkState('city'), 'not-chosen': !form.city }">
                      <option value="" class="text" disabled>City*</option>
                      <option v-for="x in City" :value="x" :key="x.id">{{x.name}}</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div>
                  <div v-if="$v.form.city.$error">
                    <p v-if="!$v.form.city.required" class="login-alert-msg error-content">* Select the city</p>
                  </div>
                </div>
                <div class="form-group">
                  <b-form-input type="text" placeholder="Postal Code*" v-model.lazy.trim="$v.form.postal_code.$model" :state="chkState('postal_code')" />
                  <div v-if="$v.form.postal_code.$error">
                    <p v-if="!$v.form.postal_code.required" class="login-alert-msg error-content">* Enter the pincode</p>
                    <p v-if="!$v.form.postal_code.minLength" class="login-alert-msg error-content">* Pincode must have at least 6 character</p>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                </div>
                <div class="form-group">
                  <button type="submit" class="btn btn-success btn-md pull-right" >Submit</button>

                </div>
              </div>

              </div>
            </b-form>
          </div>
        </div>
        <div class="form-items" style="margin-top:8% !important;" v-if="step ==2">
          <span class="logo" v-html="logos"></span>

              <div class="row mt-5">
            </div>
          <!-- <h3>Welcome to Screenit</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer placerat mi fringilla mauris ullamcorper</p> -->
          <div class="container">
            <b-form class="register-form" v-on:submit.prevent="onSubmitProfileName" novalidate style="background-color: #ffffff;padding: 20px;">
              <div >
                <div class="form-row">
                  <h3 class="float-left mb-0 ml-3">User Details</h3>
                </div>
                <hr>
                <div class="form-row">
                  <div class="form-group">
                    <b-form-input type="text" placeholder="First Name*" v-model.lazy.trim="$v.form1.firstName.$model" :state="chkState1('firstName')" />
                    <p v-if="firstname_err" class="login-alert-msg error-content">* Enter the first name</p>
                    <!-- <div v-if="$v.form1.firstName.$error">
                      <p v-if="!$v.form1.firstName.required" class="login-alert-msg error-content">* Enter the first name</p>
                      <p v-if="!$v.form1.firstName.alpha" class="login-alert-msg error-content">* Only allows alphabetic characters</p>
                    </div> -->
                  </div>
                  <div class="form-group">
                    <b-form-input type="text" placeholder="Last Name*" v-model.lazy.trim="$v.form1.lastName.$model" :state="chkState1('lastName')" />
                    <p v-if="lastname_err" class="login-alert-msg error-content">* Enter the last name</p>
                    <!-- <div v-if="$v.form1.lastName.$error">
                      <p v-if="!$v.form1.lastName.required" class="login-alert-msg error-content">* Enter the last name</p>
                      <p v-if="!$v.form1.lastName.alpha" class="login-alert-msg error-content">* Only allows alphabetic characters</p>
                    </div> -->
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <b-form-input type="text" placeholder="Email*" v-model.lazy.trim="$v.form1.emailId.$model" readonly />
                  </div>
                  <div class="form-group">
                    <b-form-input type="text" placeholder="Mobile Number" v-model.lazy.trim="$v.form1.phoneNumber.$model" readonly/>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                  </div>
                  <div class="form-group" style="text-align: end;">
                  <button type="submit" class="btn btn-success btn-sm pull-right">Done</button>
                  <!-- <button type="button" class="btn btn-default btn-md pull-right mr-11" @click="back()"><i class="fa fa-chevron-left pull-left" style="margin-top: 3px;" aria-hidden="true"></i> Back</button> -->
                  </div>
                </div>
              </div>
            </b-form>

          </div>
        </div>
      </div>
    </div>
    <my-upload field="image"
        @crop-success="cropSuccess"
        v-model="show"
        :width="200"
        :height="200"
        :params="params"
        :headers="headers"
        :langExt="zh"
        :noRotate="noRotate"
        :noSquare="noSquare"></my-upload>
  </div>
</div>
</template>

<script>
import ICountry from 'country-state-city'
import router from '../router/index'
import { BaseURLV3 } from '../shared/classes'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, url, alpha } from 'vuelidate/lib/validators'
import axios from 'axios'
import { logonew } from '../shared/svg'
import myUpload from 'vue-image-crop-upload'
// import $ from 'jquery'
// const alpha = helpers.regex('alpha', /^[a-zA-Z]*$/)
const formShape = {
  organizationType: '',
  orgwebsiteurl: '',
  organization: '',
  organizationSize: '',
  country: '',
  state: '',
  city: '',
  postal_code: ''
}
const formShape2 = {
  firstName: '',
  lastName: '',
  phoneNumber: ''
}
export default {
  name: 'userprofile',
  components: {
    'my-upload': myUpload
  },
  data () {
    return {
      formdatas: [],
      Country: ICountry.getAllCountries(),
      organizationSizeData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      OrganizationTypeData: ['IT', 'software', 'hardware'],
      State: '',
      City: '',
      noRotate: false,
      noSquare: true,
      imgformat: 'png/jpg',
      form: Object.assign({}, formShape),
      form1: Object.assign({}, formShape2),
      getOrganizationStatus: false,
      imageSource: '',
      imageAvailable: false,
      hasError: false,
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      step: 1,
      upload: false,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      logos: logonew,
      selected: null,
      value: { language: 'JavaScript', library: 'Vue-Multiselect' },
      dropdown: ['IT', 'Marketing'],
      classname: 'form-control is-valid',
      show: false,
      fileserror: 1,
      afirst: '<',
      asecond: '<',
      showfileerror: false,
      params: {
        token: '123456798',
        name: 'image',
        uid: 22
      },
      headers: {
        smail: '*_~'
      },
      imgDataUrl: '',
      profile_file: null,
      zh: {
        hint: 'Click or drag the file here to upload',
        loading: 'Uploading…',
        noSupported: 'Browser is not supported, please use IE10+ or other browsers',
        success: 'Upload success',
        fail: 'Upload failed',
        preview: 'Preview',
        btn: {
          off: 'Cancel',
          close: 'Close',
          back: 'Delete',
          save: 'Save'
        },
        error: {
          onlyImg: 'Image only',
          outOfSize: 'Image exceeds size limit: ',
          lowestPx: 'Image\'s size is too low. Expected at least: 200*200'
        }
      },
      firstname_err: false,
      lastname_err: false
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  created () {
    // if (this.userInfo === undefined || this.userInfo === null) {
    //   router.push({ name: 'LoginV3' })
    // } else if (this.userInfo.user_status !== 'Step-1') {
    //   router.push({ name: 'LoginV3' })
    // } else {
    //   this.form.emailId = this.userInfo.user_email
    //   this.form.phoneNumber = `+${this.userInfo.mobile_number_country_code}-${this.userInfo.mobile_number}`
    // }
    // this.getDatas()
  },
  mixins: [validationMixin],
  validations: {
    form1: {
      firstName: {
        required,
        alpha
      },
      lastName: {
        required,
        alpha
      },
      emailId: {

      },
      phoneNumber: {

      }
    },
    form: {
      organizationType: {
        required
      },
      organization: {
        required,
        maxLength: maxLength(64)
      },
      organizationSize: {
        required
      },
      orgwebsiteurl: {
        url
      },
      country: {
        required
      },
      state: {
        required
      },
      city: {
        required
      },
      postal_code: {
        required,
        minLength: minLength(6)
      }
    }
  },
  methods: {
    toggleShow () {
      this.show = !this.show
    },
    async cropSuccess (imgDataUrl, field) {
      console.log('-------- crop success --------', imgDataUrl)
      console.log('field ', field)
      await fetch(imgDataUrl)
        .then(r => r.blob())
        .then(blob => {
          var fileName = Math.random().toString(36).substring(6) + '_name.png' // e.g ueq6ge1j_name.jpeg
          this.profile_file = new File([blob], fileName, { type: 'image/png' })
        })
      this.imgDataUrl = imgDataUrl
      this.formdatas = []
      // const formData = new FormData()
      // formData.append('image', this.imgDataUrl)
      // formData.append('uid', this.userInfo._id)
      // this.formdatas = {
      //   image: this.imgDataUrl,
      //   uid: this.userInfo._id
      // }
      this.fileserror = 0
      this.showfileerror = false
      this.imageAvailable = true
      // axios.post(BaseURLV3 + '/profile/upload', { formData: this.formdatas }, this.config).then((response) => {
      //   this.imageAvailable = true
      // })
    },
    // cropUploadSuccess (jsonData, field) {
    //   console.log('-------- upload success --------')
    //   console.log(jsonData)
    //   console.log('field: ' + field)
    // },
    // cropUploadFail (status, field) {
    //   console.log('-------- upload fail --------')
    //   console.log(status)
    //   console.log('field: ' + field)
    // },
    getState () {
      this.State = ICountry.getStatesOfCountry(this.form.country.id)
    },
    getCity () {
      this.City = ICountry.getCitiesOfState(this.form.state.id)
    },
    getDatas () {
      axios.get(`${BaseURLV3}/dropdown/list/of/designations/type`, this.config).then(response => {
        this.dropdown = response.data.skills
        // response.data.skills.forEach(element => this.dropdown.push(element.organization_type));
      })
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    chkState1 (val) {
      const field = this.$v.form1[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    back () {
      this.step = 1
    },
    checkFormvalid () {
      console.log(this.form)
      if (this.fileserror === 1) {
        this.showfileerror = true
      }
      if (this.fileserror === 0 && this.form.organization && this.form.organizationType && this.form.organizationSize && this.form.country && this.form.state && this.form.city && this.form.postal_code) {
        console.log('success')
        this.$v.$reset()
      } else {
        console.log('error')
        this.$v.$touch()
      }
    },
    onSubmitProfileRegister () {
      console.log(this.form)
      this.checkFormvalid()
      if (this.validate()) {
        this.$nextTick(() => {
          console.log(this.form)
          const formData = new FormData()
          formData.append('org_name', this.form.organization)
          formData.append('org_web_url', this.form.orgwebsiteurl)
          formData.append('type', this.form.organizationType)
          formData.append('size', this.form.organizationSize)
          formData.append('country', this.form.country.name)
          formData.append('state', this.form.state.name)
          formData.append('city', this.form.city.name)
          formData.append('country_id', this.form.country.id)
          formData.append('state_id', this.form.state.id)
          formData.append('city_id', this.form.city.id)
          formData.append('postal_code', this.form.postal_code)
          formData.append('profile', this.profile_file)
          // this.formdatas = {
          //   image: this.imgDataUrl,
          //   uid: this.userInfo._id
          // }
          var userId = localStorage.getItem('user_id')
          axios.post(BaseURLV3 + '/org/' + userId + '/register', formData, this.config).then(response => {
            if (response.data.success) {
              console.log(response.data)
              this.step = 2
              localStorage.setItem('user__details', JSON.stringify(response.data.org))
              this.$v.$reset()
              this.form1.emailId = response.data.org.email
              this.form1.phoneNumber = `+${response.data.org.mobile_country_code}-${response.data.org.mobile}`
            } else {

            }
            // router.push({ name: 'Dashboard' })
            // router.push({ name: 'DashboardV3' })
          }).catch(e => {
            console.log(e)
          })
        })
      } else {
        console.log('validation fail................')
      }
      console.log(this.form)
    },
    onSubmitProfileName () {
      if (this.form1.firstName === '') {
        this.firstname_err = true
      } else {
        this.firstname_err = false
      }
      if (this.form1.lastName === '') {
        this.lastname_err = true
      } else {
        this.lastname_err = false
      }
      // eslint-disable-next-line camelcase, no-undef
      if (!this.firstname_err && !this.lastname_err) {
        var userInfo = JSON.parse(localStorage.getItem('user__details'))
        var orgId = userInfo.id
        // if (this.validate()) {
        var formdatas = {
          first_name: this.form1.firstName,
          last_name: this.form1.lastName
        }
        axios.post(BaseURLV3 + '/org/' + orgId + '/name', formdatas, this.config).then(response => {
          console.log(response.data)
          localStorage.setItem('user__details', JSON.stringify(response.data.org))
          // router.push({ name: 'Dashboard' })
          if (response.data.success) {
            router.replace({ name: 'DashboardV3' })
          }
        }).catch(e => {
          console.log(e)
        })
        // }
      }
    }
  }
}
</script>

<style scoped>

.form-content .form-items {
    border: none !important;
    box-shadow: none !important;
}

/* .form-content .form-items {
    background-color: #ffffff !important;
} */
.newDesign {
  width: 44%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto !important;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: -10px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.input-group.form-control.is-valid {
  background-image: none;
  padding-right: calc(1.5em + 0.75rem);
}
.input-group.form-control.is-invalid {
  background-image: none;
  padding-right: calc(1.5em + 0.75rem);
}

input.form-control.is-valid {
    background-image: none !important;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}

.form-content .form-items {
  max-width: 70%;
  padding: 25px;
  border: 1px solid #FFFFFF;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, .4);
}

svg {
  width: 100%;
}

.content-title {
  padding: 35px 0px 35px 105px;
}

.content-title-header {
  font-size: 22px;
  color: #000000;
}

.content-title-sub-header {
  color: #2F2F2F;
  font-size: 15px;
}

display-flex,
.signup-content,
.form-row,
.form-radio,
.select-icon,
.select-icon i {
  display: flex;
  display: -webkit-flex;
}

/* @extend list-type-ulli; */
list-type-ulli {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.file-loading {
  width: 50%;
}

img {
  max-width: 254px;
  height: auto;
}

figure {
  margin: 0;
}

.clear {
  clear: both;
}

.container {
  width: 100%;
  position: relative;
  margin: 0 auto;
  background: #f5f5f5;
}

.signup-img {
  width: 30%;
}

.signup-form {
  width: 70%;
}

.form-row {
  margin: 0 -15px;
}

.form-row .form-group {
  width: 50%;
  padding: 0 15px;
}

.form-group {
  margin-bottom: 15px !important;
  position: relative;
}
.form-items {
  margin-top: 2%;
}

label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
}

.form-radio {
  margin-bottom: 18px;
}

.form-radio input {
  width: auto;
  display: inline-block;
}

.radio-label {
  padding-right: 72px;
}

.form-radio-item {
  position: relative;
  margin-right: 45px;
}

.form-radio-item label {
  font-weight: 400;
  font-size: 13px;
  padding-left: 25px;
  position: relative;
  z-index: 9;
  display: block;
  cursor: pointer;
}

.check {
  display: inline-block;
  position: absolute;
  border: 1px solid #ebebeb;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  height: 13px;
  width: 13px;
  top: 4px;
  left: 0px;
  z-index: 5;
  transition: border .25s linear;
  -webkit-transition: border .25s linear;
}

.check:before {
  position: absolute;
  display: block;
  content: '';
  width: 9px;
  height: 9px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  top: 2px;
  left: 2px;
  margin: auto;
  transition: background 0.25s linear;
  -webkit-transition: background 0.25s linear;
}

input[type=radio] {
  position: absolute;
  visibility: hidden;
}

input[type=radio]:checked~.check {
  border: 1px solid #4dbd74;
}

input[type=radio]:checked~.check::before {
  background: #4dbd74;
}

.form-select {
  position: relative;
}

select {
  appearance: none !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  position: relative;
  background: 0 0;
  z-index: 10;
  cursor: pointer;
}

.select-icon {
  z-index: 999;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
}

.select-icon i {
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  width: 40px;
  height: 20px;
  font-size: 18px;
  color: #999;
}

.form-submit {
  text-align: right;
  padding-top: 27px;
}

@media screen and (max-width: 1024px) {
  /* .register-form {
    padding: 0px 40px 50px 0px;
  } */

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 125px;
  }

  .image-design {
    height: 254px;
  }

  .container {
    width: 100%;
    max-width: 100% !important;
  }
}

@media screen and (max-width: 992px) {
  .container {
    width: 100%;
    max-width: 100% !important;
  }

  .signup-img {
    width: 30%;
  }

  .signup-form {
    width: 70%;
  }

  .image-width {
    width: 100%;
    height: 100%
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }
}

@media screen and (max-width: 800px) {
  .form-content .form-items {
    max-width: 100%;
    padding: 15px;
    border: none;
    box-shadow: none;
  }

  .signup-content {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }

  .image-design {
    height: 354px;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
    text-align: center;
  }

}

@media screen and (max-width: 768px) {

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .form-content .form-items {
    max-width: 100% !important;
    padding: 15px !important;
    border: none !important;
    box-shadow: none !important;
  }
}

@media screen and (max-width: 575px) {
  .form-row {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
    margin: 0px;
  }

  .form-row .form-group {
    width: 100%;
    padding: 0px;
  }

  .radio-label {
    padding-right: 22px;
  }

  .form-radio-item {
    margin-right: 25px;
  }
}

@media screen and (max-width: 480px) {
  .form-radio {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }
}

.image-design {
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
.form-content {
    width: auto;
}
.form-row {
    margin: inherit;
}
.form-content h3 {
  margin-bottom: auto;
  margin-top: auto;
}
.mt-5 {
  margin-top: 35px;
}
.profile-image-center img {
  max-width: 100px;
  height: 100px;
}
.btn {
  width: 30%;
  height: 35px;
}
select.is-invalid {
  border: 1px solid red;
}
.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range] {
  /* display: block; */
  padding-top: 10px !important;
}
.grey_color {
  color: #ACACAC !important;
}
.edit-icon {
  position: absolute;
  top: 65%;
  right: 0%;
  background-color: #efefef;
  padding: 7px;
  border-radius: 14px;
  color: black;
  border: 1px solid #ccc;
}
</style>
